import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function TablePagination({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange,
  itemsPerPageOptions = [10, 25, 50],
  // etiqueta “Mostrando X facturas/clientes…”
  selectedCount = 0,
  selectedLabelSingular = "elemento",
  selectedLabelPlural = "elementos",
  // texto del select
  itemsLabel = "Mostrar:",
}) {
  return (
    <div className="pagination-container">
      <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ color: "#64748b", fontSize: "13px" }}>
            {itemsLabel}
          </span>

          <select
            value={itemsPerPage}
            onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
            style={{
              padding: "4px 8px",
              borderRadius: "8px",
              border: "1px solid #e2e8f0",
              cursor: "pointer",
              fontSize: "13px",
              outline: "none",
            }}
          >
            {itemsPerPageOptions.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>

        {selectedCount > 0 && (
          <span
            style={{ color: "#64748b", fontSize: "14px", fontWeight: "400" }}
          >
            Mostrando {selectedCount}{" "}
            {selectedCount === 1 ? selectedLabelSingular : selectedLabelPlural}
          </span>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <button
          className="page-button"
          style={{
            width: "auto",
            height: "32px",
            padding: "0 12px",
            opacity: currentPage === 1 ? 0.5 : 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
          }}
          disabled={currentPage === 1}
          onClick={(e) => {
            e.stopPropagation();
            onPageChange(Math.max(1, currentPage - 1));
          }}
        >
          <ChevronLeft size={14} />
          <span style={{ marginTop: "-1px" }}>Anterior</span>
        </button>

        <div style={{ display: "flex", gap: "4px" }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              className={`page-button ${currentPage === i + 1 ? "active" : ""}`}
              style={{ height: "32px", minWidth: "32px", cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                onPageChange(i + 1);
              }}
            >
              {i + 1}
            </button>
          ))}
        </div>

        <button
          className="page-button"
          style={{
            width: "auto",
            height: "32px",
            padding: "0 12px",
            opacity: currentPage === totalPages ? 0.5 : 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
          }}
          disabled={currentPage === totalPages}
          onClick={(e) => {
            e.stopPropagation();
            onPageChange(Math.min(totalPages, currentPage + 1));
          }}
        >
          <span style={{ marginTop: "-1px" }}>Siguiente</span>
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
